module.exports = __webpack_public_path__ + "img/myMessage.bb75f6f3.png";